import { render, staticRenderFns } from "./DataPrivacySettings.vue?vue&type=template&id=b81b7430&"
import script from "./DataPrivacySettings.vue?vue&type=script&lang=ts&"
export * from "./DataPrivacySettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports